import { createContext } from "react";

interface MultiProjectDashContextProps {
    toggleDemoMode: (enabled: boolean) => void;
}

export const MultiProjectDashContext = createContext<MultiProjectDashContextProps>({
    toggleDemoMode: () => {},
});